module.exports = __webpack_public_path__ + "static/media/beliefs.a22d436a.png";